export default __webpack_public_path__ + "static/media/cup.8cda1c9a.png";